module.exports = __webpack_public_path__ + "postgresql-logo.png?f5d7a0949291cb3910eb8345614a11d9";